import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverClose = PopoverPrimitive.Close

const PopoverPortal = PopoverPrimitive.Portal

const PopoverArrow = (
  props: React.ComponentProps<typeof PopoverPrimitive.Arrow>,
) => (
  <PopoverPrimitive.Arrow
    className="ui-popover-arrow fill-popover"
    {...props}
  />
)
PopoverArrow.displayName = PopoverPrimitive.Arrow.displayName

const PopoverContent = ({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) => (
  <PopoverPrimitive.Content
    align={align}
    sideOffset={sideOffset}
    className={className}
    {...props}
  />
)
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverAnchor,
  PopoverClose,
  PopoverPortal,
  PopoverArrow,
}
